import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const AccountClientContactListPage = lazy(() => import('../views/list/AccountClientContactListPage'));

export function AccountClientContactListPageLazy() {
	return (
		<PageSuspense>
			<AccountClientContactListPage />
		</PageSuspense>
	);
}
